import { Form } from 'antd';
import { useTranslation } from 'react-i18next';
import { ClientSelect } from 'src/components/Form/ClientSelect';
import { TaskFormContentCarDetails } from 'src/components/Tasks/Form/Content/CarDetails';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/** Content fields for Recognition tasks */
export var TaskFormContentRecognition = function TaskFormContentRecognition(_ref) {
  var canEdit = _ref.canEdit,
      isReadonly = _ref.isReadonly;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var isDisabled = !canEdit || isReadonly;
  return /*#__PURE__*/_jsxs(Container, {
    children: [/*#__PURE__*/_jsx(Form.Item, {
      name: ['content', 'clientId'],
      label: t('form.task.client.label'),
      rules: isDisabled ? undefined : [{
        required: true,
        message: t('form.task.client.error.required')
      }],
      children: /*#__PURE__*/_jsx(ClientSelect, {
        isReadonly: isDisabled
      })
    }), /*#__PURE__*/_jsx(TaskFormContentCarDetails, {
      isReadonly: isDisabled
    })]
  });
}; // Styles

var Container = styled.div.withConfig({
  displayName: "Recognition__Container",
  componentId: "sc-1qst0zb-0"
})([""]);